import { render, staticRenderFns } from "./AddTeam.vue?vue&type=template&id=3479c63f&scoped=true"
import script from "./AddTeam.vue?vue&type=script&lang=js"
export * from "./AddTeam.vue?vue&type=script&lang=js"
import style0 from "./AddTeam.vue?vue&type=style&index=0&id=3479c63f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3479c63f",
  null
  
)

export default component.exports